import type { Role, User } from "best-of-awards-api";

type NavItem = {
  route: { name: string };
  text: string;
};

const sorts: Partial<Record<Role, string[]>> = {
  Admin: [
    "home",
    "automations",
    "candidates",
    "contacts",
    "campaigns",
    "categories",
    "tags",
    "exports",
    "reports",
    "settings",
    "announcements",
    "graphics",
    "products",
    "users",
  ],
  Candidate: [
    "home",
    "candidate-logo",
    "sponsorships",
    "voter-rewards",
    "awards-ceremony",
    "plaques",
    "magazine",
    "graphics",
    "accounting",
  ],
  Unauthorized: [],
};

export function getNavItems(user: User): NavItem[] {
  const role = user.role ?? "Unauthorized";
  const userItems = [...items[role]];
  for (const userRole of user.roles.filter((r) => r !== role)) {
    if (!items[userRole]) {
      continue;
    }
    userItems.push(...items[userRole]);
  }
  if (sorts[role]) {
    userItems.sort(
      (a, b) =>
        sorts[role]!.indexOf(a.route.name) - sorts[role]!.indexOf(b.route.name)
    );
  }
  return userItems;
}

const items: { [key: string]: NavItem[] } = {
  Admin: [
    {
      route: { name: "home" },
      text: "Home",
    },
    {
      route: { name: "candidates" },
      text: "Candidates",
    },
    {
      route: { name: "graphics" },
      text: "Graphics",
    },
  ],
  Candidate: [
    {
      route: { name: "home" },
      text: "Home",
    },
    {
      route: { name: "candidate-logo" },
      text: "Logo",
    },
    {
      route: { name: "sponsorships" },
      text: "Sponsorships",
    },
    {
      route: { name: "voter-rewards" },
      text: "Voter Rewards",
    },
    {
      route: { name: "awards-ceremony" },
      text: "Awards Ceremony",
    },
    {
      route: { name: "plaques" },
      text: "Plaques",
    },
    {
      route: { name: "magazine" },
      text: "Magazine",
    },
    {
      route: { name: "graphics" },
      text: "Graphics",
    },
    {
      route: { name: "accounting" },
      text: "Accounting",
    },
  ],
  Campaigns: [
    {
      route: { name: "campaigns" },
      text: "Campaigns",
    },
  ],
  Announcements: [
    {
      route: { name: "announcements" },
      text: "Announcements",
    },
  ],
  Automations: [
    {
      route: { name: "automations" },
      text: "Automations",
    },
  ],
  AwardsSettings: [
    {
      route: { name: "settings" },
      text: "Settings",
    },
  ],
  Categories: [
    {
      route: { name: "categories" },
      text: "Categories",
    },
  ],
  Contacts: [
    {
      route: { name: "contacts" },
      text: "Contacts",
    },
  ],
  Exports: [
    {
      route: { name: "exports" },
      text: "Exports",
    },
  ],
  Products: [
    {
      route: { name: "products" },
      text: "Products",
    },
  ],
  Reports: [
    {
      route: { name: "reports" },
      text: "Reports",
    },
  ],
  Tags: [
    {
      route: { name: "tags" },
      text: "Tags",
    },
  ],
  Users: [
    {
      route: { name: "users" },
      text: "Users",
    },
  ],

  Unauthorized: [],
};

export default items;
